import Core            from '@/core/Core';
import VehicleType     from '@/domains/VehicleTypes/VehicleType';
import VehicleTypesDAO from '@/domains/VehicleTypes/VehicleTypesDAO';

/**
 * Сервис для работы с типами транспортов
 */
class VehicleTypesService {

	/**
	 * Загрузить один тип транспорта по id
	 */
	static async get(id: number): Promise<VehicleType | null> {
		const result = (await this.getList({ id })).data;
		return result[0] ?? null;
	}

	/**
	 * Загрузить список типов транспорта
	 */
	static async getList(
    filters?: Parameters<typeof VehicleTypesDAO.getList>[0]
  ): Promise<{ data: VehicleType[] }> {
		const response = await VehicleTypesDAO.getList(filters);

		return {
			data: Core.utils.hydrateArray(response.data, VehicleType.fromServer),
		};
	}

	/**
	 * Создать тип транспорта
	 */
	static async add(vehicleType: VehicleType): Promise<boolean> {
		const response = await VehicleTypesDAO.add(vehicleType);

		if (response.ok) {
			Core.showNotification.success('Тип транспорта успешно добавлен');
		}

		return response.ok;
	}

	/**
	 * Обновить тип транспорта
	 */
	static async update(vehicleType: VehicleType): Promise<boolean> {
		const response = await VehicleTypesDAO.update(vehicleType);

		if (response.ok) {
			Core.showNotification.success('Тип транспорта успешно обновлён');
		}

		return response.ok;
	}

	/**
	 * Удалить тип транспорта
	 */
	static async delete(id: number): Promise<boolean> {
		const response = await VehicleTypesDAO.delete(id);

		if (response.ok) {
			Core.showNotification.success('Тип транспорта успешно удалён');
		}

		return response.ok;
	}

	/**
	 * Удалить тип транспорта с подтверждением через диалог
	 */
	static async deleteWithConfirmation(vehicleType: VehicleType): Promise<boolean> {
		const confirmed = await Core.dialogs.confirm(
			'Удалить этот тип транспорта?',
			`Тип транспорта: "${vehicleType.name}"`,
		);

		if (!confirmed) return false;

		return await this.delete(vehicleType.id);
	}

  /**
   * Открыть карточку.
   * Промис резолвится по закрытию карточки.
   */
  static showVehicleTypeCard(unit: Unit | null): Promise<boolean> {
    return Core.dialogs.VehicleTypeCard.showAsPromise({ id: unit?.id ?? null });
  }
}

export default VehicleTypesService;
